import React, { useEffect, useState } from "react";
import {
  Button,
  Layout,
  Menu,
  Dropdown,
  Modal,
  Form,
  theme,
  Grid,
  Tooltip,
} from "antd";
import {
  LogoutOutlined,
  SettingOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  DownOutlined,
  DashboardOutlined,
  DollarOutlined,
  GlobalOutlined,
  CalendarOutlined,
  TeamOutlined,
  UserOutlined,
  TrophyOutlined,
  CreditCardOutlined,
  AppstoreOutlined,
  BarChartOutlined,
  WalletOutlined,
  GiftOutlined,
  BlockOutlined,
  ToolOutlined,
  ThunderboltOutlined,
  ControlOutlined,
  SafetyOutlined,
  PieChartOutlined,
} from "@ant-design/icons";
import axios from "axios";
import LeaderboardV2 from "./leaderBoardV2";
import ManualTestingStatsV2 from "./manualTestingStatsV2";
import SimcardsV2 from "./simcardsV2";
import TesterStatisticsV2 from "./testerStatisticsV2";
import ConfigSettings from "./configSettingsV2";
import FrequentApps from "./frequentlyUsedV2";
import ApplicationsV2 from "./applicationsV2";
import TeamleadsV2 from "./teamleadsV2";
import TestersV2 from "./testersV2";
import BlockedTestersV2 from "./blockedTestersV2";
import SpecialTesterStatisticsV2 from "./specialTesterStatisticsV2";
import AllTestersStats from "./paymentstatsV2";
import Bonuses from "./bonusesV2";
import TeamsV2 from "./teamsV2";
import SpecialTestingStatsV2 from "./specialTestingStatsV2";
import RoleWiseStatsV2 from "./roleWiseStatsV2";
import RoleBasedTesterStatisticsV2 from "./roleBasedTesterStatisticsV2";
import AppWiseCount from "./appwiseCountV2";
import BillingV2 from "./BillingV2";
import DashboardV2 from "./dashboardV2";
import CountryWiseOTPCountV2 from "./countrywiseOTPCountV2";
import MonthWiseOTPCountV2 from "./monthwiseOTPcountV2";
import AlltestersBannedAppsOtpCount from "./allTestersBannedAppsOtpCountV2";
import RolesV2 from "./rolesV2";
import { useNavigate } from "react-router-dom";
import ChangePasswordModal from "../shared/ChangePasswordModal";
import eonLogoLight from "../../assets/images/eon-logo-light.png";
import "./superAdminDashboardV2.css";

const { Header, Content, Footer } = Layout;
const { useBreakpoint } = Grid;
const updatePassword = process.env.REACT_APP_API_UpdatePassword;

const NAV_ITEMS = [
  {
    key: "1",
    label: "Dashboard",
    icon: <DashboardOutlined />,
    component: DashboardV2,
  },
  {
    key: "2",
    label: "Billing",
    icon: <DollarOutlined />,
    component: BillingV2,
  },
  {
    key: "3",
    label: "Country-Wise OTP Count",
    icon: <GlobalOutlined />,
    component: CountryWiseOTPCountV2,
  },
  {
    key: "4",
    label: "Month-Wise OTP Count",
    icon: <CalendarOutlined />,
    component: MonthWiseOTPCountV2,
  },
  {
    key: "22",
    label: "Roles Manager",
    icon: <SafetyOutlined />,
    component: RolesV2,
  },
  {
    key: "5",
    label: "Teams Manager",
    icon: <TeamOutlined />,
    component: TeamsV2,
  },
  {
    key: "6",
    label: "Team Leads Manager",
    icon: <UserOutlined />,
    component: TeamleadsV2,
  },
  {
    key: "7",
    label: "Testers Manager",
    icon: <UserOutlined />,
    component: TestersV2,
  },
  {
    key: "8",
    label: "Blocked Testers",
    icon: <BlockOutlined />,
    component: BlockedTestersV2,
  },
  {
    key: "9",
    label: "Leader Board",
    icon: <TrophyOutlined />,
    component: LeaderboardV2,
  },
  {
    key: "10",
    label: "Sim Cards Manager",
    icon: <CreditCardOutlined />,
    component: SimcardsV2,
  },
  {
    key: "11",
    label: "Applications Manager",
    icon: <AppstoreOutlined />,
    component: ApplicationsV2,
  },
  {
    key: "12",
    label: "Manual Testing Team Statistics",
    icon: <BarChartOutlined />,
    component: ManualTestingStatsV2,
  },
  {
    key: "13",
    label: "Special Testing Team Statistics",
    icon: <BarChartOutlined />,
    component: SpecialTestingStatsV2,
  },
  {
    key: "23",
    label: "Role-wise OTP statistics",
    icon: <PieChartOutlined />,
    component: RoleWiseStatsV2,
  },
  {
    key: "24",
    label: "Role-based tester statistics",
    icon: <TeamOutlined />,
    component: RoleBasedTesterStatisticsV2,
  },
  {
    key: "14",
    label: "Tester Statistics",
    icon: <ThunderboltOutlined />,
    component: TesterStatisticsV2,
  },
  {
    key: "15",
    label: "Special Tester Statistics",
    icon: <ThunderboltOutlined />,
    component: SpecialTesterStatisticsV2,
  },
  {
    key: "16",
    label: "Payment and Valid OTP for last month",
    icon: <WalletOutlined />,
    component: AllTestersStats,
  },
  {
    key: "17",
    label: "Bonuses for All Testers",
    icon: <GiftOutlined />,
    component: Bonuses,
  },
  {
    key: "18",
    label: "All Testers Banned Apps OTP Count",
    icon: <BarChartOutlined />,
    component: AlltestersBannedAppsOtpCount,
  },
  {
    key: "19",
    label: "Configuration Settings",
    icon: <ControlOutlined />,
    component: ConfigSettings,
  },
  {
    key: "20",
    label: "Frequently Used Apps (Manual Testers)",
    icon: <ToolOutlined />,
    component: FrequentApps,
  },
  {
    key: "21",
    label: "Frequently Used Apps (Special Testers)",
    icon: <ToolOutlined />,
    component: AppWiseCount,
  },
];

const SuperAdminDashboardV2 = () => {
  const [selectedKey, setSelectedKey] = useState("1");
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [changePasswordVisible, setChangePasswordVisible] = useState(false);
  const [form] = Form.useForm();
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const navigate = useNavigate();
  const screens = useBreakpoint();
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const onLogout = () => {
    localStorage.removeItem("setupTime");
    localStorage.removeItem("user");
    navigate("/");
    window.location.reload();
  };

  const handlePasswordChange = () => setChangePasswordVisible(true);
  const handleCancel = () => setChangePasswordVisible(false);

  const selectNavItem = (key) => {
    setSelectedKey(key);
    if (screens.md === false) setSidebarCollapsed(true); // Close sidebar on mobile after selection
  };

  const handleFinish = async (values) => {
    try {
      const { currentPassword, newPassword } = values;
      const response = await axios.put(updatePassword, {
        userId: user.userId,
        oldPassword: currentPassword,
        newPassword: newPassword,
      });
      if (response.status === 200) setChangePasswordVisible(false);
      else console.error("Password change failed");
    } catch (error) {
      console.error("Error changing password:", error);
    }
  };

  const menu = (
    <Menu>
      <Menu.Item
        key="changePassword"
        icon={<SettingOutlined />}
        onClick={handlePasswordChange}
      >
        Change Password
      </Menu.Item>
      <Menu.Item key="logout" onClick={onLogout} icon={<LogoutOutlined />}>
        Logout
      </Menu.Item>
    </Menu>
  );

  const ActiveComponent = NAV_ITEMS.find(
    (item) => item.key === selectedKey,
  )?.component;

  return (
    <Layout
      className={`sa-v2-layout ${sidebarCollapsed ? "sidebar-collapsed" : ""}`}
    >
      <aside className={`sa-v2-sidebar ${sidebarCollapsed ? "collapsed" : ""}`}>
        <div className="sa-v2-sidebar-header">
          {!sidebarCollapsed && (
            <div className="sa-v2-logo">
              <img
                src={eonLogoLight}
                alt="EON Testing Tool"
                className="sa-v2-logo-img"
              />
            </div>
          )}
          <Button
            type="text"
            icon={
              sidebarCollapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />
            }
            onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
            className="sa-v2-collapse-btn"
          />
        </div>
        <nav className="sa-v2-nav">
          {NAV_ITEMS.map((item) => (
            <Tooltip
              key={item.key}
              title={sidebarCollapsed ? item.label : null}
              placement="right"
            >
              <button
                className={`sa-v2-nav-item ${selectedKey === item.key ? "active" : ""}`}
                onClick={() => selectNavItem(item.key)}
              >
                <span className="sa-v2-nav-icon">{item.icon}</span>
                {!sidebarCollapsed && (
                  <span className="sa-v2-nav-label">{item.label}</span>
                )}
              </button>
            </Tooltip>
          ))}
        </nav>
      </aside>

      <Layout className="sa-v2-main">
        <Header className="sa-v2-header">
          <div className="sa-v2-header-left">
            <Button
              type="text"
              icon={
                sidebarCollapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />
              }
              onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
              className="sa-v2-mobile-menu-btn"
              aria-label="Toggle sidebar"
            />
            <h1 className="sa-v2-page-title">
              {NAV_ITEMS.find((i) => i.key === selectedKey)?.label ||
                "Dashboard"}
            </h1>
          </div>
          <div className="sa-v2-header-right">
            <Dropdown
              overlay={menu}
              trigger={["click"]}
              placement="bottomRight"
            >
              <button className="sa-v2-user-btn" aria-label="Account menu">
                <span className="sa-v2-user-avatar">
                  {user.name
                    ?.split(" ")
                    .map((w) => w[0])
                    .join("")
                    .slice(0, 2)
                    .toUpperCase()}
                </span>
                <span className="sa-v2-user-name">
                  {user.name
                    ?.split(" ")
                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(" ")}
                </span>
                <DownOutlined className="sa-v2-user-chevron" />
              </button>
            </Dropdown>
          </div>
        </Header>

        <Content
          className="sa-v2-content"
          style={{
            padding: screens.xs ? "16px" : "24px",
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
          }}
        >
          <div className="sa-v2-content-inner">
            {ActiveComponent && <ActiveComponent />}
          </div>
        </Content>

        <Footer className="sa-v2-footer">
          EON Testing Tool ©{new Date().getFullYear()} Created by EON
          Intelligence
        </Footer>
      </Layout>

      <ChangePasswordModal
        open={changePasswordVisible}
        onCancel={handleCancel}
        onFinish={handleFinish}
        form={form}
      />
    </Layout>
  );
};

export default SuperAdminDashboardV2;
